import {
  Component, Inject, OnInit, OnDestroy, Input, ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { CoursesService } from 'src/app/services/courses.service';
import { UsersService } from 'src/app/services/users.service';
import { Observable, Subscription } from 'rxjs';
import { RequirementsService } from 'src/app/services/requirements.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-quick-people-push',
  templateUrl: './quick-people-push.component.html',
  styleUrls: [ './quick-people-push.component.scss' ],
})
export class QuickPeoplePushComponent implements OnInit, OnDestroy {
  @ViewChild('requirementsinput') requirementsinput: any;
  @ViewChild('userinput') userinput: any;
  @Input() completeCourseSessionDetails: any;
  coursePushSubscription: any;
  coursePushPackage: any = {
    users: [], requirementId: [], messageContent: '',
  }
  isLoading = false;
  currentScreen = 'index'
  formattedCourseRequirements: any;
  error: any;
  userDataSubscription = new Subscription();
  usersData$: Observable<any>;
  users = []
  requirementsDataSubscription = new Subscription();
  requirementsData$: Observable<any>;
  requirements: any;

  constructor(
    private toastService: ToastService,
    private requirementsService: RequirementsService,
    private usersService: UsersService,
    private coursesService: CoursesService,
    public dialogRef: MatDialogRef<QuickPeoplePushComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    // this is where we format the course requirements for our select dropdown
    this.formattedCourseRequirements = this.completeCourseSessionDetails?.Course?.Requirements?.map((requirement: any) => {
      return {
        text: requirement.requirement,
        value: requirement.requirementId,
      }
    })
    // this is where we call for the index of course item pushes
    this.usersData$ = this.usersService.usersData$
    const params = {
      userNameFilter: '',
      activeFlag: 1 as 0 | 1,
      sortColumn: 'lastName',
      sortDirection: 'ASC' as 'ASC' | 'DESC',
      // limit: 2,
      offset: 0,
      includedAssociations: '',
    };

    this.usersService.getUsers(params);
    this.userDataSubscription = this.usersData$.subscribe(data => {
      if (!data) return;
      this.users = data.rows;
    })

    this.requirementsData$ = this.requirementsService.requirementsData$
    this.requirementsService.getRequirements()
    this.requirementsDataSubscription = this.requirementsData$.subscribe(data => {
      if (!data) return;
      this.requirements = data.rows;
    })
  }

  updateCoursePushPackageParameter = (event: any, parameter: any) => {
    let newValue;
    if (parameter === 'users') {
      // if the user is already in the list, clear the form and return
      if (this.coursePushPackage[parameter].find((user: any) => user.fullName === event.target.value)) {
        this.userinput.nativeElement.value = '';
        return
      }
      const newUser = this?.users?.find((user: any) => user.fullName === event.target.value);
      newValue = [ ...this.coursePushPackage[parameter], newUser ];
      this.userinput.nativeElement.value = '';
      const newCoursePushPackage = { ...this.coursePushPackage, [parameter]: newValue }
      this.coursePushPackage = newCoursePushPackage;
    }
    if (parameter === 'requirement') {
      this.coursePushPackage.requirementId = Number(event)
    }
  }

  removeUser = (user: any) => {
    this.coursePushPackage.users = this.coursePushPackage.users.filter((item: any) => item !== user);
  }

  submitPush = () => {
    const formattedUserIds = this.coursePushPackage.users.map((user: any) => parseFloat(user.id));
    const formattedPushPackage: any = {
      'requirementId': this.coursePushPackage.requirementId,
      'userIds': formattedUserIds,
      'courseId': parseFloat(this.completeCourseSessionDetails.Course.id), // REQ
      'courseItemId': parseFloat(this.completeCourseSessionDetails.id), // REQ
      'messageBody': this.coursePushPackage.messageContent,
    }

    if (this.coursePushPackage.users.length === 0 || this.coursePushPackage.requirementId === null) {
      return
    }

    this.isLoading = true;
    this.coursePushSubscription = this.coursesService.quickPeoplePush(formattedPushPackage).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.coursePushPackage = {
          requirementId: [], users: [], messageContent: '',
        }
        this.coursesService.getCoursePushes({ 'courseItemId': this.completeCourseSessionDetails.id, 'includedAssociations': 'Requirement, Building, Position, Push' })
        this.closeModal()
        this.toastService.setToast({
          text: 'Push Created', type: 'success', icon: true,
        })
      },
      error: (error: any) => {
        console.log('error', error);
        this.error = error;
      },
    })
  }

  closeModal = () => {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.coursePushSubscription?.unsubscribe();
  }

}
